import * as React from 'react';

import ActionButton from 'components/buttons/action-button/ActionButton';
import VerticalSpacing from 'components/vertical-spacing/VerticalSpacing';
import { withModal } from 'components/modal/ModalHOC';

import SOVModalMeta from 'modules/insights/sov/components/modals/meta/SOVModalMeta';
import SOVCalloutV2 from '../SOVCalloutV2';

import { __t, applyTranslations } from 'utils/language';
import { CREATE } from 'modules/insights/sov/utils/sov';
import { getCommonModalProps } from 'modules/insights/sov/utils/modals/sov-report-modal';

import type { SOVGeneralProps, SOVReportType } from 'modules/insights/sov/types';

import './sov-callout-report.scss';

applyTranslations(require('./sov-callout-report.i18n.json'));

const AddNewWithMetaModal = withModal(ActionButton, {
  modalContent: SOVModalMeta
});

type Props = {
  hasYouTube: boolean,
  onClick: (props: SOVGeneralProps) => void
};

const MSG_KEY = 'sov_callout_report';

class SOVCalloutReport extends React.PureComponent<Props> {
  private getItems(): React.ReactNode {
    return (
      <ul className="sov-callout-report__items">
        {
          ['step_one', 'step_two', 'step_three'].map(step => (
            <li key={step}>
              {__t(`${MSG_KEY}.${step}`)}
            </li>
          ))
        }
      </ul>
    );
  }

  private renderLink(): React.ReactNode {
    return (
      <a
        href="https://help.collabary.com/en/articles/2440882-creating-a-share-of-voice-report"
        className="sov-callout-report__link"
        target="_blank"
        rel="noopener noreferrer"
      >
        {__t(`${MSG_KEY}.link`)}
      </a>
    );
  }

  private renderButton(type: SOVReportType): React.ReactNode {
    const { onClick } = this.props;

    return (
      <AddNewWithMetaModal
        className="sov-callout-report__button"
        color="primary"
        modalContentProps={{
          ...getCommonModalProps(CREATE, type),
          onAction: onClick
        }}
      >
        {__t(`${MSG_KEY}.button_${type}`)}
      </AddNewWithMetaModal>

    );
  }

  private renderButtons(): React.ReactNode {
    const { hasYouTube } = this.props;

    return (
      <div className="sov-callout-report__buttons">
        {this.renderButton('instagram')}
        {hasYouTube && this.renderButton('youtube')}
      </div>
    );
  }

  private renderTeaser(): React.ReactNode {
    return (
      <React.Fragment>
        {this.getItems()}
        <VerticalSpacing type="large" />
        <img
          src="/static/images/sov-report-callout.png"
          className="sov-callout-report__teaser"
          alt=""
        />
      </React.Fragment>
    );
  }

  render(): React.ReactNode {
    return (
      <SOVCalloutV2
        headerText={__t(`${MSG_KEY}.header`)}
        content={this.renderLink()}
        teaser={this.renderTeaser()}
        button={this.renderButtons()}
        className="sov-callout-report"
      />
    );
  }
}

export default SOVCalloutReport;
